export default "__VITE_ASSET__CknXOrT4__"